import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast, successToast } from "../../../utils/toasts";

export function useUpdateSpotlightExtension(advertisementId: number) {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["advertising"]);
  return useMutation({
    mutationFn: async (vars: Parameters<typeof apiClient.updateSpSpotlightVideoSpec>[0]) =>
      await apiClient.updateSpSpotlightVideoSpec(vars, { params: { id: advertisementId } }),
    onSuccess: (_, vars) => {
      successToast({
        message: t(($) => $.advertising["Spotlight ad extension for ASIN {asin} successfully updated"], {
          asin: vars.asin,
        }),
      });
      void queryClient.invalidateQueries({
        queryKey: [{ endpoint: "getSpVideo" }],
      });
    },
    onError: (error, vars) => {
      let errorMessage = t(($) => $.advertising["Error updating spotlight ad extension for ASIN {asin}."], {
        asin: vars.asin,
      });
      if (isAxiosError<{ message: string }>(error) && error.response?.data.message) {
        errorMessage += ` ${error.response.data.message}`;
      }
      errorToast({ message: errorMessage, error });
    },
  });
}
